import SessionTab from './top/_session';
import Sphoto from './top/_smartphoto';

const session = new SessionTab();
const sphoto = new Sphoto();